namespace Matrix.Rebalancer {
    export interface ModellingViewColumnSetForm {
        ColumnSetCode: Serenity.StringEditor;
        Name: Serenity.StringEditor;
        Columns: ModellingViewColumnGrid;
        Formats: ModellingViewFormatGrid;
        CreatedBy: StaticTextBlock;
        CreatedWhen: ReadOnlyDateTime;
        UpdatedBy: StaticTextBlock;
        UpdatedWhen: ReadOnlyDateTime;
        Version: StaticTextBlock;
    }

    export class ModellingViewColumnSetForm extends Serenity.PrefixedContext {
        static formKey = 'Rebalancer.ModellingViewColumnSet';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ModellingViewColumnSetForm.init)  {
                ModellingViewColumnSetForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = ModellingViewColumnGrid;
                var w2 = ModellingViewFormatGrid;
                var w3 = StaticTextBlock;
                var w4 = ReadOnlyDateTime;

                Q.initFormType(ModellingViewColumnSetForm, [
                    'ColumnSetCode', w0,
                    'Name', w0,
                    'Columns', w1,
                    'Formats', w2,
                    'CreatedBy', w3,
                    'CreatedWhen', w4,
                    'UpdatedBy', w3,
                    'UpdatedWhen', w4,
                    'Version', w3
                ]);
            }
        }
    }
}
